import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { goToMenu } from 'bento-ordering/cart/actions/orderSettings';

import Drawer from 'bento-ordering/base/components/Drawer';
import CartContainer from 'bento-ordering/cart/containers/CartContainer';
import ModalContainer from 'bento-ordering/base/containers/ModalContainer';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

class CartDrawer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  };

  handleClose = () => {
    this.props.dispatch(goToMenu());
  };

  render() {
    return (
      <ModalContainer>
        <Drawer handleClose={this.handleClose}>
          <CartContainer />
        </Drawer>
      </ModalContainer>
    );
  }
}

export default withGoogleLibraryLoaded(connect()(CartDrawer));
